module.exports = __webpack_public_path__ + "img/logo_grit.92979e5a.png";